"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAudio = exports.isVideo = exports.isImage = exports.getFileMd5 = exports.getEtag = void 0;
var etag_1 = require("uss-vod-js-sdk/lib/src/etag");
Object.defineProperty(exports, "getEtag", { enumerable: true, get: function () { return etag_1.getEtag; } });
var md5_1 = require("uss-vod-js-sdk/lib/src/md5");
Object.defineProperty(exports, "getFileMd5", { enumerable: true, get: function () { return md5_1.getFileMd5; } });
var utils_1 = require("uss-vod-js-sdk/lib/src/utils");
Object.defineProperty(exports, "isImage", { enumerable: true, get: function () { return utils_1.isImage; } });
Object.defineProperty(exports, "isVideo", { enumerable: true, get: function () { return utils_1.isVideo; } });
Object.defineProperty(exports, "isAudio", { enumerable: true, get: function () { return utils_1.isAudio; } });
